/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configure_Batch_Transcription_JobsInputs */



/**
* | output |
* | --- |
* | "Configure and submit batch transcription jobs" |
*
* @param {Configure_Batch_Transcription_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const configure_batch_transcription_jobs = /** @type {((inputs?: Configure_Batch_Transcription_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configure_Batch_Transcription_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer et soumettre des tâches de transcription par lot")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konfigurieren und Übermitteln von Stapeltranskriptionsaufträgen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurare e inviare lavori di trascrizione in batch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка и отправка заданий пакетной транскрипции.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar y enviar trabajos de transcripción por lotes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置并提交批量转录作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチ転写ジョブの設定と送信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच ट्रांसक्रिप्शन जॉब्स को कॉन्फ़िगर करें और सबमिट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configure e envie trabalhos de transcrição em lote.")
	return /** @type {LocalizedString} */ ("Configure and submit batch transcription jobs")
});